<template>
  <div>
    <div class="form-row">
      <div class="form-group col-md-12 col-xl-4">
        <label class="required" for="frmNameCC">{{ $t('message.cardHolderName') }}</label>
        <input
          autocomplete="cc-name"
          v-validate="'cardholder'"
          id="frmNameCC"
          v-model="editModel.CardHolder"
          name="cardHolderName"
          type="text"
          class="form-control"
        />
        <div
          class="invalid-feedback"
        >{{ OOErrors.first("cardHolderName") | inputNameLocale("cardHolderName")}}</div>
      </div>
      <div class="form-group col-md-6 col-xl-4">
        <label class="required" for="frmCCNum">{{ $t('message.cardNumber') }}</label>
        <input
          autocomplete="cc-number"
          v-validate="'required|credit_card|CardNumberValidation'"
          id="frmCCNum"
          v-model="editModel.CardNumber"
          name="cardNumber"
          type="text"
          class="form-control"
          :placeholder="getCardNumberLang"
          maxlength="19"
          v-mask="'#### #### #### ####'"
        />

        <div
          class="invalid-feedback"
        >{{ OOErrors.first("cardNumber") | inputNameLocale("cardNumber")}}</div>
        <p style="padding: 2px; font-size: 14px;">{{ cardLimitMessage }}</p>
      </div>

      <div class="form-group col-md-4 col-xl-2 over-flow-x-hidden">
        <label class="required" for="frmCCExp">{{ $t('message.expiryDate') }}</label>
        <input
          autocomplete="cc-exp"
          v-validate="{ required: true, CartValidation:12 }"
          id="frmCCExp"
          v-model.trim="editModel.ExpireDate"
          type="text"
          name="expiryDate"
          class="form-control"
          placeholder="MM/YY"
          v-mask="'##/##'"
        />
        <div
          class="invalid-feedback"
        >{{ OOErrors.first("expiryDate") | inputNameLocale("expiryDate")}}</div>
      </div>
      <div class="form-group col-md-2 col-col-xl-2">
        <label class="required" for="frmCCCVC">{{ $t('message.CVV') }}</label>
        <input
          autocomplete="cc-csc"
          v-validate="{ required: true, regex: /^[0-9]{3,4}$/ }"
          id="frmCCCVC"
          v-model="editModel.CVV"
          name="CVV"
          type="text"
          class="form-control"
          placeholder="111"
          v-mask="[checkStripeEnabled ? '####' : '###']"
        />
        <div class="invalid-feedback">{{ OOErrors.first("CVV") | inputNameLocale("CVV")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "card-component",
  directives: { mask },
  props: {
    editModel: {
      type: Object,
      default: () => {},
    },
    Title: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      cardType: "master",
    };
  },
  watch: {
    "editModel.CardNumber": function (val) {
      this.$validator.validate("cardNumber").then((res) => {
        setTimeout(() => {
          if (res) this.setCardNumber(val);
            else this.clearCardType();
        }, 1);
      });
    },
    "editModel.ExpireDate": function (newValue) {
      if (newValue.length > 4) {
        let splitedValue = newValue.split("/");
        if (splitedValue[0] > 12) {
          this.editModel.ExpireDate = splitedValue[1] + "/" + splitedValue[0];
        }else if (splitedValue[1].length > 3)
        {
          this.editModel.ExpireDate = splitedValue[0] + "/" + splitedValue[1].slice(-2);
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      "selectedLocale",
      "viewConfig",
      "currentStoreDoc",
      "hqDoc"
    ]),
    getCardNumberLang() {
      return this.$t("message.cardNumber");
    },
    cardLimitMessage() {
      let locale = typeof this.selectedLocale === 'object'
        ? this.selectedLocale.locale
        : this.selectedLocale;
      locale = locale.toLowerCase();

      let stripeEnabled = !!this.currentStoreDoc.StripeActivated;
      if (this.isBranded() && this.hqDoc) {
        stripeEnabled = !!this.hqDoc.StripeActivated;
      }
      const accepted = [
        this.$t('message.visa'),
        this.$t('message.mastercard'),
      ];
      if(stripeEnabled) {
        accepted.push(this.$t('message.amex'));
      }

      const last = accepted.pop();
      if(locale === 'en') {
        const names = accepted.join(', ');
        return `We accept ${names} & ${last} only`;
      } else if(locale === 'zh-cn') {
        const names = accepted.join('，');
        return `我们仅接受${names}和${last}`;
      } else {
        return null;
      }
    },
    checkStripeEnabled() {
      if (this.isBranded() && this.hqDoc) {
        return !!this.hqDoc.StripeActivated;
      }else
      {
        return !!this.currentStoreDoc.StripeActivated
      }
    }
  },
  methods: {
    ...mapActions(["setCardNumber", "clearCardType"]),
    validate() {
      return this.$validator.validateAll();
    },
  },
};
</script>
<style lang="scss" scoped>
.card-vaidation {
  .invalid-feedback {
    display: block;
  }
}
</style>